export default "__VITE_ASSET__CZeezuWM__"